import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, } from "@angular/core";
import { FormGroup,  FormBuilder, Validators, FormArray } from "@angular/forms";
import { AdminService } from "../../../../services/admin.service";
import { apiUrl } from "../../../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-preview",
  templateUrl: "./preview.component.html",
  styleUrls: ["./preview.component.css"]
})
export class PreviewComponent implements OnInit {
  isStepper;
  @Input() filledData: any;
  @Input() isAdd: any;
  @Output() valueChange = new EventEmitter();
  @Output() stepperChange = new EventEmitter();
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  objectProp: any;
  // data
  allJobs;
  jobId;
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };
  // form
  form: FormGroup;
  showError: boolean = false;
  pagename;
  title:string="";
  constructor(public route: ActivatedRoute,private router: Router,private modalService: BsModalService, private formBuilder: FormBuilder, private api: AdminService, private toastrService: ToastrService) {
    this.form = this.formBuilder.group({  
      id: [""],
      jobTitle: [""],
      categoryId: [""],
      subCategoryId: [""],
      industryId: [""],
      description: [""],
      workPlaceLocation: [""],
      skillIds: [""],
      address: [],
      employementTypeId: [""],
      scheduleId: [""], 
      // second
      payOption: [""],
      minimum: [""],
      maximum: [""],
      price: [""],
      rate: [""],
      benefitsIds: [""],
      supplementalPayId: [""],
      // third & four
      addCustomQuestion: [],
      // five 
      jobEligibleForId: [""],
      vaccinationCerificate: [""],
      quicklyNeedForHireId: [""],
      travelRequirementId: [""],
      noOfPeopleRequired: [""],
      personalitiesIds: [""],
      countryCode: [""],
      phoneNumber: [""],
      emailsIds: [],      
      isConfirm: [""],
      isAccepted: ["", Validators.compose([Validators.required])],
    })
   }
  back() {
    this.stepperChange.emit({ step : 5 });
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.jobId = params['jobId'];
      if(this.jobId){
        // this.getJobs()
      }
    }) 
  }
  ngOnChanges(filledData: any) { 
   if(filledData != undefined && filledData.filledData.currentValue != undefined){
      this.filledData = filledData.filledData.currentValue; 
      this.jobId=this.filledData.JobPost?.id;
      this.jobId=this.jobId;
      this.allJobs =this.filledData;
      let skillid:any=[];
      this.filledData?.JobPostSkills.map((skill)=>{
        skillid.push({skillId:skill.skillId})
      })
      let supplementalPayid:any=[];
      this.filledData?.supplementalPay.map((pay)=>{
        supplementalPayid.push({supplementalPayId:pay.supplementalPayId})
      })
      let benefitsid:any=[];
      this.filledData?.JobPostBenefits.map((beni)=>{
        benefitsid.push({benefitsId:beni.benefitsId})
      })
      let personalitiesid:any=[];
      this.filledData?.JobPostPersonalities.map((per)=>{
        personalitiesid.push({personalitiesId:per.personalitiesId})
      })
      let jobEligibleForid:any=[];
      this.filledData?.jobEligibleFor.map((elg)=>{
        jobEligibleForid.push({jobEligibleForId:elg.jobEligibleForId})
      })
      let emailid:any=[];
      this.filledData?.JobPostNotificationEmails.map((email)=>{
        emailid.push({emailId:email.emailId})
      })
      let subCategoryIds:any=[];
      this.filledData?.subCategory.map((subCat)=>{ 
        subCategoryIds.push({categoryId:subCat.categoryId,subCategoryId:subCat.subCategoryId}) 
      })
      
      let addQuestion:any=[];
      this.filledData?.JobPostAddQuestions.map((question)=>{
        addQuestion.push({addScreeningQuestionId:question.addScreeningQuestionId,title:question.title,experience:question.experience,responseType:question.responseType,answer:question.answer})
      })
      let address:any=[];
      this.filledData?.address.map((addr)=>{
        if((addr?.latitude != null) && (addr?.longitude != null)){
          address.push({location:addr.location,state:addr.state,city:addr.city,zipCode:addr.zipCode,latitude:addr.latitude,longitude:addr.longitude})
        } else {
          address = [];
        }
      })
      this.form.patchValue({
        id:this.filledData?.JobPost?.id,
        jobTitle:this.filledData?.JobPost?.jobTitle,
        categoryId:this.filledData?.JobPost?.categoryId,
        industryId:this.filledData?.JobPost?.industryId,
        description:this.filledData?.JobPost?.description,
        workPlaceLocation:this.filledData?.JobPost?.workPlaceLocation,
        employementTypeId:this.filledData?.JobPost?.employementTypeId,
        scheduleId:this.filledData?.JobPost?.scheduleId,
        payOption:this.filledData?.JobPost?.payOption,
        minimum:this.filledData?.JobPost?.minimum,
        maximum:this.filledData?.JobPost?.maximum,
        price:this.filledData?.JobPost?.price,
        rate:this.filledData?.JobPost?.rate,
        steps:this.filledData?.JobPost?.steps,
        vaccinationCerificate:this.filledData?.JobPost?.vaccinationCerificate.toString(),
        quicklyNeedForHireId:this.filledData?.JobPost?.quicklyNeedForHireId,
        travelRequirementId:this.filledData?.JobPost?.travelRequirementId,
        noOfPeopleRequired:this.filledData?.JobPost?.noOfPeopleRequired,
        countryCode:this.filledData?.JobPost?.countryCode,
        phoneNumber:this.filledData?.JobPost?.phoneNumber,
        skillIds:skillid,
        subCategoryId:subCategoryIds,
        supplementalPayId:supplementalPayid,
        benefitsIds:benefitsid,
        personalitiesIds:personalitiesid,
        jobEligibleForId:jobEligibleForid,
        emailsIds:emailid,
        addCustomQuestion:addQuestion,
        address:address,
        isConfirm:this.filledData?.JobPost?.isConfirm
      })
    }
  }
  getJobs(){ 
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getJobs+"/"+this.jobId)
    .subscribe(async (res) => { 
      this.allJobs = res.data; 
      console.log(this.allJobs,'allJobs');
      
    })
  }
  
  openModal(template: TemplateRef<any>) { 
    this.modalRef = this.modalService.show(
      template,
      Object.assign({},this.config, { class: "modal-sm addModal centerAlign" })
    ); 
  }
  next(){
    // this.showThankyou =true 
    setTimeout(() => {
      // this.showThankyou =false 
      this.modalRef?.hide();
        this.router.navigate(["/jobs"]);
      }, 3000);
  }

  onSubmit(template: TemplateRef<any>){ 
   
    if(this.form.value.isAccepted == false ){
      this.showError = true 
      setTimeout(() => {
        this.showError = false
      }, 1200);
      return
    }
    if(this.form.valid){
      if (this.router.url.indexOf('jobs/edit') > -1) {
        if(this.filledData?.JobPost?.isConfirm===0 && this.filledData?.JobPost?.steps===5){
           this.form.patchValue({isConfirm:1})
        }
        this.title="Job has been Edited successfully"; 
        delete this.form.value.isAccepted;  
        this.api.putData(apiUrl._getJobs, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => {
        this.openModal(template);
        setTimeout(() => {
          this.modalRef?.hide();
            this.router.navigate(["/jobs"]);
          }, 3000);
      })
    }  else{
      this.title="Job has been listed successfully";
      this.form.patchValue({isConfirm:1})
      delete this.form.value.isAccepted; 
      this.api.postData(apiUrl._saveJobs, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.openModal(template);
        setTimeout(() => {
          this.modalRef?.hide();
            this.router.navigate(["/jobs"]);
          }, 3000);
      })
    }
      
    } else{
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 2000);
    }
  }
  
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }

  onPreviewEdit(event,number){
    if(number == 1){
      this.stepperChange.emit({ step : 1 });
    } else if(number == 2){
      this.stepperChange.emit({ step : 2 });
    }else if(number == 3){
      this.stepperChange.emit({ step : 3 });
    }else if(number == 5){
      this.stepperChange.emit({ step : 5 });
    }
  }
}
